import { render, staticRenderFns } from "./ResumeHistoryModal.vue?vue&type=template&id=8590954c&"
import script from "./ResumeHistoryModal.vue?vue&type=script&lang=js&"
export * from "./ResumeHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports